export enum IntegrationStepType {
  account = 'Account',
  product = 'Product'
}
